<!--课程组件 父-->
<template>
  <el-card :body-style="{padding:'0px'}">
    <div class="cf-title cf">
      <div class="cf-title-line"/>
      <label>{{ module.title }}</label>
      <router-link style="margin-left: auto;margin-right: 10px;color: #999999" v-if="module.skip_page_id"
                   :to="{name: 'IndexModules',params: { page_id: module.skip_page_id },query:{title:module.title}}">
        查看更多
      </router-link>
    </div>
    <div style="width: 100%;height: 1px;background-color: #f2f2f2;"></div>
    <el-row :gutter="0">
      <class-card
          v-for="item in normal_list"
          :item="item"
          :key="item.id">
      </class-card>
    </el-row>
  </el-card>
</template>

<script>
import ClassCard from "./ClassCard"

export default {
  name: "class-section",
  props: ['module'],
  components: {
    ClassCard
  },
  created: function () {
    for (var i = 0; i < this.module.contentpagecourse_datas.length; i++) {
      var item = this.module.contentpagecourse_datas[i];
      this.normal_list.push(item);
    }
  },
  data() {
    return {
      normal_list: []
    }
  }
}
</script>

<style scoped>
@import "../../common/style/classsection.css";

.amore {
  font-size: 12px !important;
  line-height: 31px;
}

.cf-main {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Content/ClassSection.vue